// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__XLndJ","footerSection":"Footer_footerSection__t-d+X","footerSectionLinks":"Footer_footerSectionLinks__08U5e"};